<template>
  <section id="special-category">
    <h1><span class="underline">{{ title }}</span></h1>
    <carousel-3d v-if="specials" class="top"
      :key="slider3d"
      :autoplay="true"
      :display="display"
      :perspective="0"
      :width="width"
      :height="height"
      :space="space"
      :border="0">
      <slide v-for="(item, i) in top3" :index="i" :key="i">
        <template slot-scope="{ index, isCurrent, leftIndex, rightIndex }">
          <a :href="item.link" target='_blank'>
            <img :data-index="index" :class="{ current: isCurrent, onLeft: (leftIndex >= 0), onRight: (rightIndex >= 0) }" :src="item.image_url">
            <h3><span class="has-text-black">{{ item.title }}</span></h3>
          </a>
        </template>
      </slide>
    </carousel-3d>
    <div class="special-items">
      <div class="item" v-for="(item, i) in items">
        <a :href="item.link" target='_blank'>
          <img :src="item.image_url" :alt="item.title">
        </a>
      </div>
    </div>
    <button v-if="more" class="load-more has-text-white has-background-black has-text-centered" @click="loadMore()">
      LOAD MORE
    </button>
    <transition name="fade">
      <Loading v-show="isLoading" />
    </transition>
  </section>
</template>

<script>
import { mapState } from 'vuex'
import { Carousel3d, Slide } from 'vue-carousel-3d'
import Loading from 'src/components/common/Loading'

export default {
  data() {
    return {
      isLoading: true,
      slider3d: 0,
      display: 3,
      width: 320,
      height: 390,
      space: 180,
      itemCount: 9,
      perPage: 8
    }
  },
  components: { Carousel3d, Slide, Loading },
  watch: {
    isMobile: function () {
      if (this.isMobile) {
        this.height = 390
        this.width = 320
        this.space = 180
      } else {
        this.height = 550
        this.width = 440
        this.space = 480
      }
      this.slider3d += 1
    }
  },
  computed: {
    ...mapState(['specials', 'isMobile']),
    top3: function () {
      return this.specials ? this.specials.categories.find(c => c.path == this.$route.params.category).specials.slice(0, 3) : null
    },
    items: function () {
      return this.specials ? this.specials.categories.find(c => c.path == this.$route.params.category).specials.slice(3, this.itemCount) : null
    },
    title: function () {
      return this.specials ? this.specials.categories.find(c => c.path == this.$route.params.category).title : ''
    },
    more: function () {
      return this.specials ? (this.specials.categories.find(c => c.path == this.$route.params.category).specials.length - this.itemCount) > 0 : null
    }
  },
  methods: {
    loadMore: function() {
      if (!this.isLoading && this.specials) {
        this.itemCount += this.perPage
      }
    }
  },
  created() {
    if (window.innerWidth >= 1200) {
      this.height = 550
      this.width = 440
      this.space = 480
      this.itemCount = 11
      this.slider3d += 1
    }
    if (!this.specials) {
      this.$store.dispatch('loadSpecials').then(() => {
        this.isLoading = false
      })
    } else {
      this.isLoading = false
    }
  }
}
</script>

<style lang="scss">
#special-category {
  h1 {
    margin: 30px 0;
    font-size: 26px;
    font-weight: 500;
    line-height: 30px;
    letter-spacing: 3px;
    text-align: center;
    & .underline {
      position: relative;
      z-index: 1;
      &::after {
        content: '';
        height: 6px;
        background: #FFC2AE;
        position: absolute;
        left: -10px;
        right: -10px;
        bottom: -5px;
        z-index: -1;
      }
    }
  }
  .top {
    margin: 45px 0;
  }
  .carousel-3d-slide {
    background-color: #FFFFFF;
    h3 {
      margin-top: 8px;
      font-size: 16px;
      font-weight: 500;
      line-height: 28px;
      letter-spacing: 1px;
      text-align: center;
      span {
        background-color: #FFDBCF;
        padding: 3px;
      }
    }
    .onLeft + h3, .onRight + h3 {
      display: none;
    }
  }
  .special-items {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-evenly;
    align-content: space-evenly;
    padding: 70px 0;
    max-width: 1200px;
    margin: auto;
    .item {
      position: relative;
      margin: 10px;
      height: 43vw;
      width: 43vw;
      max-height: 250px;
      max-width: 250px;
      img {
        height: 100%;
        width: 100%;
        object-fit: cover;
      }
    }
  }
  button.load-more {
    display: block;
    cursor: pointer;
    margin: 40px auto;
    width: 144px;
    height: 34px;
    font-size: 16px;
    line-height: 150%;
    letter-spacing: 1px;
    border: none;
    border-radius: 50px;
    &:hover {
      -webkit-transform: scale(1.1);
      -ms-transform: scale(1.1);
      transform: scale(1.1);
      -webkit-transition: all .5s;
      -o-transition: all .5s;
      transition: all .5s;
    }
  }
}
</style>
